exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2019\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.card-layout {\n  flex: 1 1;\n  position: relative;\n  min-width: 300px;\n}\n\n.card-layout .card-layout-content .widget .widgetHeader .widgetTitle * {\n  color: #343334;\n  font-size: 16px;\n  text-align: left;\n  font-weight: 700;\n}\n\n.card-layout .widget .attachedView.expanded {\n  top: 35px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-1!./node_modules/postcss-loader??ref--1-2!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js??ref--1-4!./src/js/layout/explorecard/exploreCard.scss
// module id = 422
// module chunks = 0